/* eslint no-trailing-spaces: 0 */

const messages = {
  'params': {
    'label': 'Русский'
  },
  'service': {
    'flow-and-time': 'Расход воды и время работы',
    'ro-membrane': 'Эффективность работы ОО',
    'temperature': 'Температура',
    'leakage': 'Обнаружение протечки',
    'pressure': 'Давление воды',
    'co2': 'Углекислый газ'
  },
  'service-short': {
    'flow-and-time': 'Расход воды и время',
    'ro-membrane': 'ОО',
    'temperature': 'Температура',
    'leakage': 'Протечки',
    'pressure': 'Давление',
    'co2': 'CO2'
  },
  'sensor': {
    'flow': 'Расходомер',
    'tds': 'Датчик TDS',
    'temperature': 'Датчик температуры',
    'leakage': 'Датчик протечки',
    'pressure': 'Датчик давления'
  },
  'user-params': {
    username: 'Имя пользователя',
    email: 'E-mail',
    password: 'Пароль',
    password_reinput: 'Повторите пароль',
    password_reinput_differs: 'Пароли не совпадают.',
    role: 'Роль'
  },
  'role': {
    'administrator': 'Администратор',
    'manager': 'Менеджер',
    'staff': 'Сервис-инженер'
  },
  'btn': {
    'add': 'Добавить',
    'edit': 'Изменить',
    'cancel': 'Отмена',
    'update': 'Обновить',
    'save': 'Сохранить',
    'ok': 'OK',
    'delete': 'Удалить'
  },
  'validate': {
    'phone-format': 'Пожалуйста, используйте только цифры!',
    'phone-length': 'Телефонный номер должен быть менее 128 цифр',
    'select': 'Пожалуйста, выберите',
    'vali-required': 'Обязательное поле.'
  },
  cognitoError: {
    UserNotFoundException: 'Имя пользователя не найдено.',
    UsernameExistsException: 'Такой пользователь уже создан.',
    UserNotConfirmedException: 'Регистрация пользователя не подтверждена.',
    NotAuthorizedException: 'Неправильные имя пользователя или пароль.',
    LimitExceededException: 'Превышено количество попыток входа, попробуйте позже.',
    CodeMismatchException: 'Неверный код верификации. Попробуйте еще раз.',
    InvalidParameterException: 'Задан неверный параметр.',
    UnknownError: 'Неизвестная ошибка.'
  },
  signup: {
    signup: 'Регистрация нового пользователя',
    register: 'Зарегистрировать нового пользователя',
    btn_check_email: 'Проверьте свою электронную почту',
    buy_iotizr: 'Купить контроллер',
    signupConfirmDialogText: 'Продолжить?',
    signupSuccessDialogText: 'Мы получили Ваш запрос на регистрацию. Вскоре вы получите письмо на указанный Вами адрес электронной почты. Пожалуйста, пройдите по ссылке из письма для подтверждения регистрации.'
  },
  'login': {
    'login': 'Логин',
    'lost': 'Забыли пароль?',
    'link_to_signup': '(en)Sign up',
    'vali-username-blank': 'Требуется имя пользователя.',
    'vali-password-blank': 'Требуется пароль.',
    'next': 'Далее',
    'incorrect': 'Неправильный пароль или имя пользователя.'
  },
  'resetpassword': {
    'title': 'Сброс пароля',
    'detail': 'Введите имя пользователя',
    'entercode': 'Введите код подтверждения.',
    'newpassword': 'Новый пароль',
    'codedetail': 'Письмо с кодом подтверждения было отправлено с адреса "no-reply@verificationemail.com" на указанный Вами при регистрации адрес. Проверьте вашу почту и введите код подтверждения.',
    'resendcode': 'Повторно отправить код',
    'vali-code-blank': 'Требуется код подтверждения.',
    'vali-pass-blank': 'Требуется новый пароль.',
    'vali-pass-number': 'Пароль должен состоять из цифр (0-9) и латинских букв (a-z).',
    'vali-pass-length': 'Пароль должен быть длиннее 7 символов.',
    'vali-pass-whitespace': 'Пароли, содержащие пробелы, не могут быть установлены.',
    'confirm': 'Подтвердить'
  },
  activate: {
    title: 'Активация учетной записи',
    detail: 'Проверьте свою электронную почту и введите имя пользователя и временный пароль. Измените временный пароль, введя новый пароль.',
    temp_password: 'Временный пароль',
    newpassword: 'Новый пароль',
    passwordreinput: 'Повторите новые пароль',
    agreement: 'Соглашение',
    agreement_msg: 'Эта услуга предоставляется вам Ecosoft и Aplix Corporation. Используя эту услугу, вы принимаете и соглашаетесь с Условиями обслуживания Aplix HARPS (<a href =\'http://www.aplix.co.jp/en/legal/terms_harps.php\' target = \'_ blank \'> Условиями использования HARPS </a>, <a href=\'http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php\' target=\'_blank\'> Политикой конфиденциальности</a>) и арбитражом перед Международной торговой палатой по любым спорам между нами.',
    agree: 'Я прочел соглашение и принимаю его положения.',
    you_need_to_agree: 'Необходимо согласиться.',
    submit: 'Подтвердить',
    complete: 'Активация выполнена'
  },
  'global-menu': {
    'dashboard': 'Главная',
    'watersystem': 'Мониторинг',
    'customer': 'Управление локациями',
    'setting': 'Настройки',
    'pc': '!!! PC Management'
  },
  'home': {
    'notification': 'Оповещения',
    'information': 'От {0}',
    'mail-notification-top': 'Теперь доступны оповещения по электронной почте.',
    'mail-notification-under': 'Пожалуйста, подтвердите свой адрес <a href=\'{0}\'>здесь</a>',
    'quick-link': 'Быстрый доступ',
    'calendar': 'Календарь обслуживания',
    'quick-link-settings': 'Настройки быстрого доступа',
    'notification-alert': 'Достигнут порог оповещения',
    'notification-warning': 'Достигнут порог напоминания'
  },
  'watersystem': {
    'column-nexttime': 'Ожидаемая дата следующего обслуживания',
    'customer-name': 'Название локации',
    'customer': 'Локации',
    'organization-name': 'Организация',
    'device-name': 'Название фильтра',
    'device': 'Фильтры',
    'deviceinfo': 'Информация о фильтре',
    'filter-life-left': 'Осталось ресурса картриджей',
    'filter': 'Картридж',
    'flow-rate': 'Расход воды',
    'flow': 'Поток воды',
    'history': 'История',
    'list': 'Показывать по',
    'mapinfo': 'Карта',
    'name': 'Название',
    'period-month': ', месяцы',
    'purification-amount': 'объем очищенной воды',
    'RoMembrane': 'Эффективность работы мембраны ОО',
    'RoMembrane-short': 'Состояние мембраны ОО',
    'RoMembrane-good': 'Хорошее',
    'RoMembrane-caution': 'Удовлетворительное',
    'RoMembrane-alert': 'Нужна замена',
    'Pressure': 'Датчик давления',
    'Pressure-short': 'Давление',
    'Pressure-good': ' Хорошее',
    'Pressure-caution': 'Удовлетворительное',
    'Pressure-alert': 'Проблема!',
    'service': 'Мониторинг',
    'status': 'Статус',
    'delete-water-system': 'Удалить {0}.\nВся история будет удалена.',
    'delete-water-system-with-iotizr': 'Привязанный контроллер будет продолжать передачу данных.\nЕсли Вы хотите прекратить связь с контроллером, отключите его от электропитания или отвяжите его с помощью приложения.',
    'delete-water-system-ask': 'Вы действительно хотите удалить?',
    'error-delete': 'Удаление не удалось',
    'succeed-delete': 'Успешно удалено',
    'filter-reset': 'Отметить замену картриджей',
    'please-select': 'Выберите фильтр.',
    'elapsed-time': 'Прошло времени',
    'total-flow': 'Очищено воды',
    'customer-info': 'Локация',
    'rest-flow': 'Осталось ресурса',
    'filter-reset-title': 'Внимание!',
    'filter-reset-text': 'Вы действительно хотите сделать отметку о замене картриджей? Счетчики времени и расхода воды будут сброшены.',
    'filter-reset-do': 'Выполнить',
    'filter-reset-cancel': 'Отмена',
    'threshold': 'Порог',
    'notification-threshold': 'Порог оповещения',
    'about-flow-and-time': 'О пороговых значениях расхода воды и времени',
    'about-ro-membrane': 'О пороговых значениях эффективности работы мембраны',
    'about-temperature': 'О пороге температуры',
    'about-pressure': 'О пороговых значениях давления',
    'custom': 'Свои значения',
    'use-preset': 'По умолчанию',
    'flow-life': 'Ресурс по объему воды',
    'time-life': 'Ресурс по времени',
    'alert': 'Оповещение',
    'warning': 'Напоминание',
    'use-flow': 'Тип расходомера',
    'need-sensor': 'Необходимые датчики',
    'about-flow-and-time-text': 'Измеряется расход и объем воды, очищаемой фильтром в течении некоторого времени. При превышении объема очищенной воды или времени мы отправим Вам оповещение.',
    'about-ro-membrane-text': 'Датчики измеряют содержание растворенных примесей о исходной воде и очищенной воде после мембраны ОО. По этим данным расчитывается эффективность удаления примесей мембраной. При снижении эффективности удаления мы пришлём Вам оповещение.',
    'about-pressure-text': 'Измеряется давление воды в точке установки датчика. Возможно подключение нескольких датчиков при наличии свободных портов. При отклонении давления от заданного мы пришлём Вам оповещение.',
    'about-temperature-text': 'Измеряется температура в месте установки датчика. Возможна установка нескольких датчиков. При изменении температуры мы отправим Вам оповещение.',
    'about-setting-flow-and-time-text': 'Задайте значения объема очищенной воды ([UNIT]) и времени (месяцы), при достижении которых будет создано напоминание и оповещение.',
    'about-setting-ro-membrane-text': 'Задайте значения эффективности работы мембраны (%), при достижении которых будет создано предупреждение и оповещение.',
    'about-setting-temperature-text': 'Задайте значения температуры, при достижении которых будет создано предупреждение и оповещение.',
    'about-setting-pressure-text': 'Задайте значения давления, при достижении которых будет создано предупреждение и оповещение.',
    'about-threshold-setting': 'О настройке пороговых значений',
    'headline-press-alert': 'Давление воды ниже, чем заданный порог оповещения.',
    'headline-press-warning': 'Давление воды ниже, чем заданный порог предупреждения.',
    'headline-press-normal': 'На данный момент все значения давления в норме.',
    'headline-diff-press-alert': 'Перепад давления за пределами порога оповещения.',
    'headline-diff-press-warning': 'Перепад давления за пределами порога напоминания.',
    'headline-temperature-up-alert': 'Значение температуры выше порога оповещения.',
    'headline-temperature-up-warning': 'Значение температуры выше порога напоминания.',
    'headline-temperature-down-alert': 'Значение температуры ниже порога оповещения.',
    'headline-temperature-down-warning': 'Значение температуры ниже порога напоминания.',
    'now-pressure': 'Текущее значение давления',
    'vali-threshold-must': 'Необходимые поля',
    'vali-threshold-num': 'Пожалуйста, введите число!',
    'vali-threshold-min': 'Значение ниже измеряемой температуры.',
    'vali-threshold-max': 'Значение выше измеряемой температуры.',
    'vali-threshold-min-comm': 'Пожалуйста, укажите {0} или больше.',
    'vali-threshold-max-comm': 'Пожалуйста, укажите {0} или меньше.',
    'vali-threshold-integer': 'Пожалуйста, введите целое число!',
    'vali-threshold-limit100': 'Пожалуйста, введите число менее 100',
    'vali-threshold-positive-integer': 'Пожалуйста, введите число больше или равное 0!',
    'impurities-removal-rate': 'Качество удаления примесей',
    'entrance-impurity-content': 'Содержание примесей на входе',
    'exit-impurity-content': 'Содержание примесей в очищенной воде',
    'time-elapsed': 'Времени прошло',
    'pressure': 'Давление воды',
    'setting-link-text1': 'Для изменения значений задайте "Порог оповещения" в',
    'setting-link-text2': 'настройках',
    'setting-link-text3': '',
    'vali-threshold-alert-less-than': 'Пожалуйста, задайте значение меньше порога оповещения',
    'vali-threshold-greater-than-warning': 'Пожалуйста, задайте значение больше порога напоминания',
    'vali-threshold-warning-less-than': 'Пожалуйста, задайте значение меньше порога напоминания',
    'vali-threshold-greater-than-alert': 'Пожалуйста, задайте значение больше порога оповещения',
    'last-update': 'Обновлено',
    'past-pressure': 'Значение давления в {0}',
    'last-update-for-chart': 'Последнее обновление',
    'last-update-week-suffix-for-chart': 'неделя {0}',
    'last-impurities-removal-late': 'Текущая эффективность очистки',
    'past-impurities-removal-late': 'эффективность очистки в {0}',
    'differential-pressure': 'Значения перепада давления',
    'about-differential-pressure-text': 'Перепад давления определяется путем измерения давления в двух точках и расчета разницы полученных значений. При превышении перепада давления мы отправим Вам оповещение.',
    'about-setting-differential-pressure-text': 'Задайте пороговые значения перепада давления для напоминания/оповещения.',
    'differential-pressure-need-sensor': '2 датчика давления',
    'differential-pressure-value': 'Значение перепада давления',
    'leakage-all-normal': 'На данный момент протечки отсутствуют',
    'return-to-normal': 'Протекание прекратилось',
    'leakage-alert': 'Обнаружена протечка',
    'detection-history': 'История протечек',
    'no-water-leak-history': 'История протечек отсутствует.',
    'headline-leakage-alert': 'Сработал датчик протечки! Проверьте место размещения фильтра.',
    'leakage-normal': 'Протечек нет',
    'leakage': 'Датчик протечки',
    'leakage-short': 'Датчик протечки',
    'temperature-short': 'Датчик температуры',
    'temperature-alert': 'Оповещение',
    'temperature-warning': 'Напоминание',
    'temperature-normal': 'Всё хорошо',
    'temperature-min': 'или больше',
    'temperature-max': 'или меньше',
    'temperature-increase': 'Сообщение при превышении порога',
    'temperature-decrease': 'Сообщение при снижении ниже порога',
    'temperature-content': 'Температура',
    'temperature-select-label': 'Правила оповещения',
    'now-temperature': 'Текущая температура',
    'past-temperature': 'Температура в {0}'
  },
  'chart': {
    'dataZoom-zoom': 'Масштаб',
    'dataZoom-back': 'Сброс масштаба',
    'change-period': 'Выбор периода',
    'button-reload': 'Обновить',
    'graph-label-fromlastchange': 'Объем очищенной воды с последней замены картриджей',
    'graph-label-diff': 'Объем очищенной воды за период',
    'graph-label-sum': 'Общий объем очищенной воды',
    '15m': '15 минут',
    '1h': '1 час',
    '1d': '1 день',
    '1w': '1 неделя',
    '1M': '1 месяц',
    'auto-reload': 'Автообновление',
    'label-date': 'Дата',
    'label-time': 'Время',
    'button-date-jump': 'Перейти',
    'button-date-recent': 'Недавние',
    'button-ok': 'ОК',
    'button-cancel': 'Отмена',
    'message-oldest': 'Отображение построено от самых старых значений, поскольку данные на выбранный момент времени невозможно показать по центру.',
    'message-latest': 'Отображенаются последне данные, поскольку данные на выбранный момент времени невозможно показать по центру.',
    'message-outbounds-oldest': 'Отображение построено от самых старых значений, поскольку данные на выбранный момент времени отсутствуют.',
    'message-outbounds-latest': 'Отображенаются последне данные, поскольку данные на выбранный момент времени отсутствуют.',
    'message-no-data': 'Нет данных.'
  },
  'csv-download': {
    'button-csv-download': 'Скачать отчет',
    'button-download': 'Скачать',
    'start-datetime': 'Начальная дата и время',
    'end-datetime': 'Конечная дата и время',
    'failed-download-no-data': 'Отсутствуют данные для скачивания',
    'failed-create-zip-file-fatal': 'Скачивание не удалось из-за возникшей ошибки.',
    'failed-create-zip-file-busy': 'Сервер занят. Повторите попытку позже.',
    'invalid-start-end-datetime': 'Некорректные даты: начальная дата раньше конечной даты.'
  },
  /* 英語統一のため使用しない 2019/01/17 R.Inoue
  'csv-header': {
    'datetime': 'Дата и время',
    'organization-name': 'Организация',
    'location-name': 'Локация',
    'device-name': 'Фильтр',
    'flow-log-status': 'Состояние',
    'flow-log-flow': 'Всего очищено воды({0})',
    'flow-log-flow-diff': 'Очищено воды за период({0})',
    'ro-rate-log-status': 'Качество удаления примесей',
    'ro-rate-log-rate': 'Степень удаления примесей(%)',
    'temperature-log-status': '{0}:Температура',
    'temperature-log-temperature': '{0}:Температура({1})',
    'leakage-log-status': '{0}:Протечки воды',
    'water-pressure-log-status': '{0}:Давление',
    'water-pressure-log-pressure': '{0}:Значение давления({1})'
  },
  */
  'user': {
    'unselected': 'Выберите организацию.',
    'nodata': 'Нет пользователей.',
    'username': 'Имя пользователя',
    'email': 'E-mail',
    'role': 'Роль',
    'edit-setting': 'Изменить'
  },
  'organizations': {
    'title': 'Список организаций',
    'button-add': 'Добавить организацию',
    'button-add-pc': 'Add P/C Accounts',
    'vali-create-limit': '(en)Subordinate organization can not be created because it is restricted',
    'limit-settings': '(en)Organization creation limit',
    'no-limit': '(en)Unlimited'
  },
  'device': {
    'name': '[en] device name',
    'vali-device-name': '[en] device name is required.'
  },
  'settings': {
    'title': 'Настройки',
    'unit': 'Единицы объема',
    'timezone': 'Часовой пояс',
    'timezone-location': 'Местный часовой пояс',
    'pressureUnit': 'Единицы давления',
    'temperatureUnit': 'Единицы температуры',
    'display-setting': 'Настройки отображения',
    'available-sensor': 'Датчики',
    'life-and-notification': 'Ресурс картриджей и оповещения',
    'notification-presets': 'Шаблоны оповещений',
    'notification-mail': 'E-mail для оповещений',
    'organization-user': 'Организации и пользователи',
    'management-organization': 'Управление организациями',
    'user-management': 'Управление пользователями',
    'user-invitation': 'Добавить пользователя',
    'add-organization': 'Добавить организацию',
    'pc-management': 'P/C Management',
    'set-up': 'Обновить'
  },
  'account': {
    'delete-organization': 'Удалить организацию',
    'basic-information': 'Основная информация',
    'organization': 'Название организации',
    'parent-organization': 'Родительская организация',
    'description': 'Описание',
    'tel': 'Телефон',
    'email': 'E-mail',
    'contact': 'Контакт',
    'incharge': 'Контактное лицо',
    'administrator': 'Администратор',
    'name': 'Имя (необязательно)',
    'username': 'Ответственный пользователь',
    'useremail': 'E-mail ответственного',
    'company': 'Имя компании',
    'address': 'Адрес',
    'created': 'Дата регистрации',
    'edit': 'Изменить',
    'caution-title': 'Внимание!',
    'caution-org-remove-text': 'Вы действительно хотите удалить указанную ниже организацию?',
    'caution-user-remove-text': 'Вы действительно хотите удалить указанного ниже пользователя?',
    'caution-location-remove-text': 'Вы действительно хотите удалить указанную ниже локацию?',
    'delete': 'Удалить',
    'cancel': 'Отмена',
    'close': 'Закрыть',
    'create': 'Создать',
    'updated': 'Обновлено',
    'error-delete': 'Ошибка удаления.',
    'error-customer': 'Имеются привязанные локации.',
    'error-user': 'Имеются привязанные пользователи.',
    'error-root': 'Это корневая организация.',
    'error-system': 'Имеются привязанные фильтры.',
    'header-title': 'Управление организациями и пользователями',
    'header-org': 'Управление организациями',
    'header-user': 'Управление пользователями',
    'header-invite': 'Добавить пользователя',
    'header-pc': 'P/C Management',
    'invite-btn': 'Отправить письмо с приглашением',
    'policy': 'Лицензионное положение',
    'agree': 'Согласен',
    'csv-import': 'Мы планируем добавить функцию импорта CSV',
    'label-role': 'Роль',
    'label-parent': 'Родительская организация',
    'label-belongto': 'Организация',
    'label-organization': 'Организация',
    'label-account': 'Учетная запись',
    'label-username': 'Ответственный пользователь',
    'label-useremail': 'E-mail ответственного',
    'success-dialog': 'Приглашение успешно отправлено.',
    'vali-username-must': 'Необходимо имя пользователя.',
    'vali-username-format': 'Должно состоять из букв, цифр и символов (. - _ @)',
    'vali-username-char': 'Имя пользователя должно содержать 4-20 символов.',
    'vali-email-must': 'Необходим адрес электронной почты.',
    'vali-email-format': 'Введите валидный адрес.',
    'vali-phone-format': 'Допустимы только цифры.',
    'vali-phone-length': 'Телефон должен быть короче 128 цифр.',
    'vali-role': 'Пожалуйста, выберите',
    'vali-org-select': 'Пожалуйста, выберите',
    'vali-org-name': 'Необходимо название организации.',
    'vali-location-name': 'Необходимо название локации.',
    'fail-registration': 'Регистрация не удалась',
    'fail-username': 'Указанное имя пользователя не может быть зарегистрировано',
    'fail-master-name': 'Нельзя сменить организацию верхнего уровня.',
    'can-edit-message': 'Вы можете редактировать роль и организацию.',
    'cant-edit-yourself': 'Нельзя редактировать себя.',
    'update-succeed': 'Успешно обновлено',
    'delete-succeed': 'Успешно удалено',
    'function-limit': 'Некоторые функции не могут быть использованы для текущей учетной записи',
    'cant-delete-yourself': 'Нельзя удалить себя.'
  },
  'viewable-locations': {
    'header-viewable-locations': 'Управление видимостью локаций',
    'button-add-viewable-locations': 'Добавить видимые локации',
    'label-permit-viewing-locations': 'Разрешить видимые локации',
    'select-is-not-limited-viewer': 'Все локации',
    'select-is-limited-viewer': 'Только выбранные локации',
    'label-viewing-target-locations': 'Видимые локации',
    'hint-viewing-target-locations': 'Пожалуйста, выберите видимые локации',
    'button-set': 'Установить',
    'button-cancel': 'Отмена'
  },
  'customer': {
    'add': 'Добавить локацию',
    'latitude': 'Широта',
    'longitude': 'Долгота',
    'info': 'Основная информация',
    'situation': 'Отчет об использовании',
    'active-device': 'Активный фильтр',
    'others': 'Другие',
    'geo-location': 'Широта/долгота',
    'defined': 'указаны.',
    'undefined': 'неизвестны.',
    'situation-title': 'Итоги',
    'print': 'Печать',
    'target': 'Цель',
    'sum': 'Сумма',
    'history': 'История',
    'iotizr-situation': 'Данные о контроллере',
    'service-plan': 'Сервисный план',
    'device-customer': 'Фильтр (локация)',
    'date': 'Дата',
    'name': 'Локация',
    'device': 'Фильтр',
    'organization': 'Организация',
    'address': 'Адрес',
    'tel': 'Телефон',
    'open-map': 'Найти место на карте',
    'close-map': 'Закрыть карту',
    'content': 'Содержание',
    'get-address': 'Получить адрес',
    'search': 'Поиск',
    'error-location': 'Не удается найти широту и долготу',
    'error-delete': 'Не удалось удалить.',
    'error-delete-connecting-device': 'Сначала отвяжите контроллер(ы) этой локации в приложении и попробуйте снова.',
    'success-delete': 'Успешно удалено.'
  },
  'notifications': {
    'header-title': 'Ресурс картриджей и уведомления',
    'header-preset': 'Шаблоны уведомлений',
    'header-mail': 'Адрес для уведомлений',
    'title-mail': 'Адрес для уведомлений',
    'title-langage': 'Выбор языка',
    'japanese': 'Japanese',
    'english': 'English',
    'russian': 'Русский',
    'enable': 'Получать',
    'disable': 'Не получать'
  },
  'profile': {
    'profile': 'Ваш профиль',
    'role': 'Роль',
    'organization': 'Организация',
    'email': 'E-mail',
    'new-email': 'Новый e-mail',
    'change-email': 'Изменить e-mail',
    'change-password': 'Изменить пароль',
    'old-password': 'Текущий пароль',
    'new-password': 'Новый пароль',
    'confirm-new-password': 'Повторите новый пароль',
    'cancel': 'Отмена',
    'change': 'Изменить',
    'submit': 'Сохранить',
    'confirm': 'Подтвердить',
    'resend': 'Повторить e-mail',
    'continue': 'Продолжить',
    'confirmation-code': 'Введите код подтверждения',
    'confirmation-code-input': 'Введите код подтверждения',
    'change-password-error': 'Неверный старый пароль.',
    'not-verified': 'Ваш e-mail не подтвержден!',
    'verify': 'Подтвердить',
    'verified': 'Ваш e-mail подтвержден',
    'vali-blank-new-pass': 'Пожалуйста, введите новый пароль',
    'vali-blank-old-pass': 'Пожалуйста, введите текущий пароль',
    'vali-blank-confirm-new-pass': 'Пожалуйста, подтвердите новый пароль',
    'vali-format': 'Пароль должен быть не меньше 8 символов и содержать минимум одну цифру (0-9)',
    'vali-length': 'Должен быть не более 25 символов',
    'vali-same-password': 'Пароли не совпадают!.',
    'vali-empty-code': 'Введите код подтверждения',
    'vali-email-format': 'Укажите действительный e-mail',
    'vali-invalid-code': 'Неверный код подтверждения',
    'code-confirm-text1': 'На ваш e-mail отправлено письмо с кодом подтверждения.',
    'code-confirm-text2': 'Проверьте свой e-mail и введите код подтверждения ниже.',
    'code-confirm-title': 'Введите код подтверждения',
    'code-confirm-input': 'Код подтверждения',
    'change-email-title': 'Сменить e-mail',
    'change-password-title': 'Сменить пароль',
    'success-resend': 'На ваш e-mail отправлено письмо с кодом подтверждения.\n Если Вы не получили письмо, пожалуйста, попробуйте еще раз позже.',
    'fail-resend': 'Повторная отправка не удалась',
    'fail-error': 'Превышено количество попыток, попробуйте еще раз позже.',
    'changed-password': 'Ваш пароль обновлен'
  }
}

module.exports = messages



// WEBPACK FOOTER //
// ./src/assets/connect_ecosoft_com/translations/russian.js